module.exports = __webpack_public_path__ + "img/aneuguide.fbe2e4c3.png";